import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { accountQuery, cmsPagesQuery, hostBaseUrl } from '@/api';
import { bannersFromPages, type Banner, type BannerPosition } from '@/domain';
import { useTranslations } from '@/i18n/TranslationsProvider';

export function useBanners(position: BannerPosition): Banner[] {
  const { data: account } = useQuery(accountQuery());
  const { selectedLanguage } = useTranslations();
  const accountGuid = account?.Guid ?? '';

  const { data } = useQuery({
    ...cmsPagesQuery(accountGuid, selectedLanguage),
    enabled: Boolean(accountGuid && selectedLanguage),
  });

  return useMemo(() => {
    if (!accountGuid || !data?.Data) return [];
    return bannersFromPages(data.Data, position, hostBaseUrl('users'), accountGuid);
  }, [accountGuid, data, position]);
}
